/**
 * **S1 — the attack's entity overlay.** The first stage of `attack.ts`'s `resolveSingleTarget`
 * pipeline: which overlay the effects engine reads for this resolution. The caller's own, the
 * hand-modeled {@link SEED_OVERLAY} when an {@link EffectsConfig} arrived without one, or
 * `undefined` for a resolve that opts out of the effects engine (the bare attack spine).
 *
 * This stage used to also pre-answer the overlay's `spatial` predicates off the live map. That op
 * is gone (`decisions/0183`): positional conditions are geometry ops that read the map when they
 * are evaluated, and a fact the map can't answer is a `gm_ruling` the GM answers through the
 * resolution's `choices`.
 */

import { SEED_OVERLAY, type LoadedOverlay } from "../effects";
import type { EffectsConfig } from "./types";

export function attackOverlay(effects: EffectsConfig | undefined): LoadedOverlay | undefined {
  return effects?.overlay ?? (effects ? SEED_OVERLAY : undefined);
}
